export enum CollisionType {
  noSrConnection,
  incidentWithSr,
  srLeaves,
  temporalChange,
  others = 99,
}
